import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import RootThemeProvider, {
  GlobalStyles,
} from "@deloitte-omnia/core-fe-mfe/RootThemeProvider";
import "@deloitte-omnia/core-fe-mfe/src/scss/app.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { msalConfig } from "../src/authentication/authConfig";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { history, store } from "./store/index";
import "./styles/styles.scss";

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

if (
  process.env.REACT_APP_ENV === "production" ||
  process.env.REACT_APP_ENV === "development"
) {
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter>
        <RootThemeProvider>
          <GlobalStyles />
          <MsalProvider instance={msalInstance}>
            <App history={history} pca={msalInstance} />
          </MsalProvider>
        </RootThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
